import React from "react";
import Grid from "@material-ui/core/Grid";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import styles from "./AuthFooter.module.css";
import { toggleMode, selectIsLoginView } from "../../features/auth/authSlice";
import useMedia from "use-media";

const AuthFooter: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const isLoginView = useSelector(selectIsLoginView);
  const isWide = useMedia({ minWidth: "600px" });
  const isWideL = useMedia({ minWidth: "960px" });

  return (
    <Grid container component="footer">
      <Grid item xs={12}>
        <div
          className={isWideL ? styles.footerL : styles.none}
          onClick={() => dispatch(toggleMode())}
        >
          <div
            className={isWide ? styles.footer : styles.none}
            onClick={() => dispatch(toggleMode())}
          >
            <div
              className={!isWide ? styles.footerRes : styles.none}
              onClick={() => dispatch(toggleMode())}
            >
              <span>{isLoginView ? "新規登録画面へ" : "ログイン画面へ"}</span>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default AuthFooter;
